<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>

        <div class="table-list inner">
          <h2 class="title">{{ $t("連携情報") }}</h2>
          <div class="content">
            <div class="table table-bordered">
              <div class="my-3 d-flex flex-column align-items-center">
                <div class="form-group row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ $t("取引先") }}
                  </label>
                  <div class="col-sm-8">
                    <select
                      v-model="form.partnerId"
                      class="form-control"
                      id="exampleFormControlSelect1"
                    >
                      <template>
                        <option></option>
                        <option
                          v-for="(item, index) in master.partners"
                          :key="index"
                          :value="item.id"
                        >{{ $t(item.name) }}</option>
                      </template>
                    </select>
                    <p>{{ $t('既存の取引先に連携せず、自動的に新規登録する場合には未選択のまま登録を行ってください。') }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-column">
              <p class="text-danger text-center" v-if="error">{{ error }}</p>
              <div class="d-flex justify-content-between mt-4 mb-4">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="cancel()"
                  :disabled="isRegistering"
                >{{ $t("キャンセル") }}</button>
                <button
                  type="button"
                  class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
                  @click="register()"
                  :disabled="isRegistering"
                >
                  <div
                    class="d-flex justify-content-center align-items-center mr-3"
                    v-if="isRegistering"
                  >
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </div>
                  {{ $t("登録") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </common-template>
</template>

<script>
import qs from 'querystringify'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      list: [],
      pageTitle: '連携登録',
      master: {},
      form: {
        ediToken: '',
        partnerId: null,
      },
      error: '',
      isRegistering: false,
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    const query = qs.parse(location.search)
    if (!query.edi_token) {
      window.location.href = this.$appConfig.ScreenUrl.settingMenu
    }
    this.form.ediToken = query.edi_token

    try {
      await this.$store.dispatch('auth/user')
      const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`, {
        headers: {
          'Authorization': this.authorization ? this.authorization : null,
        },
      })
      this.master = res.data
    } catch (err) {
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    }
  },
  methods: {
    async register() {
      this.isRegistering = true

      try {
        await this.$axios({
          method: 'post',
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/edi_approval/`,
          data: this.cleanForm,
        })

        window.location.href = this.$appConfig.ScreenUrl.partnerList
      } catch (e) {
        console.log(e)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      } finally {
        this.isRegistering = false
      }
    },
    cancel() {
      window.location.href = this.$appConfig.ScreenUrl.ediRedirect + location.search
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
    cleanForm: function() {
      const form = {}
      for (let [k, v] of Object.entries(this.form)) {
        if (v !== null && v !== '' && v !== void 0) {
          form[k] = v
        }
      }
      return form
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
